import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1549d2eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "send-usage",
    class: "send-usage"
};
const _hoisted_2 = { class: "send-usage__header" };
const _hoisted_3 = { class: "send-usage__title" };
const _hoisted_4 = { class: "send-usage__subtitle" };
const _hoisted_5 = { class: "send-usage__items" };
const _hoisted_6 = { class: "send-usage__item" };
const _hoisted_7 = { class: "send-usage__item" };
const _hoisted_8 = { class: "send-usage__item" };
import { computed } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SendUsage',
    setup(__props) {
        const store = useStore();
        const getNonOfficial = computed(() => {
            return store.getters.getNonOfficial;
        });
        const renewalDate = computed(() => {
            return moment(getNonOfficial.value.startDate).format('DD/MM/YY');
        });
        const percentage = computed(() => {
            return (getNonOfficial.value.balance / getNonOfficial.value.limit) * 100;
        });
        const getMonthAndYear = computed(() => {
            const [year, month] = getNonOfficial.value.startDate.split('-');
            const monthNumber = Number(month);
            const date = new Date(0, monthNumber - 1);
            const monthName = date.toLocaleString(store.state.language, { month: 'long' });
            const capitalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1);
            return `${capitalizedMonth} ${year}`;
        });
        const daysUntil = computed(() => {
            const startDate = getNonOfficial.value.startDate;
            if (!startDate)
                return 0;
            const diff = new Date(startDate).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0);
            return Math.ceil(diff / 86400000);
        });
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('settings.send-usage.title-page', { date: getMonthAndYear.value })), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('settings.send-usage.phrase', {
                        date: '17/07/25',
                        hours: '08:42',
                    })), 1)
                ]),
                _createVNode(_component_base_card_v2, null, {
                    default: _withCtx(() => [
                        _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.$t('settings.send-usage.scheduled')), 1),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.send-usage.available')), 1),
                                _createElementVNode("b", null, _toDisplayString(getNonOfficial.value.limit), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.send-usage.consumed')), 1),
                                _createElementVNode("b", null, [
                                    _createTextVNode(_toDisplayString(getNonOfficial.value.balance) + " ", 1),
                                    _createElementVNode("small", null, "(" + _toDisplayString(percentage.value) + "%)", 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.send-usage.renewal-date')), 1),
                                _createElementVNode("b", null, [
                                    _createTextVNode(_toDisplayString(renewalDate.value) + " ", 1),
                                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('settings.send-usage.remaining', {
                                        days: daysUntil.value,
                                    })), 1)
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
